module.exports = __webpack_public_path__ + "static/media/history_26.42b3e856.jpg";